export class DebounceModule {
	timeouts = [];
	debounce2(_function, delay = 100, args = null, context = this) {
		// console.log('would debounce', _function);
		this.timeouts.forEach((timeout) => {
			// console.log('clearing timeout', timeout);
			clearTimeout(timeout);
		});

		let timeout = setTimeout(() => {
			// console.log('setTimeOut > call function');
			if (context && args) {
				_function.apply(context, args);
			} else {
				_function.apply(this);
			}
		}, delay);
		this.timeouts.push(timeout);
	}

	debounce(_function, delay = 100) {
		let timeout;
		// spread any arguments passed to this function declaration
		// and immediately return
		return function(...args) {
			// clear any time out if present
			//console.log('clearing timeout');
			clearTimeout(timeout);
			// call settimeout with this current
			// lexical scope and the given delay parameter
			timeout = setTimeout(() => {
				//console.log('setTimeout', this, _function);
				
				// and apply this scope and arguments to the
				// function which is to be debounced				
				_function.apply(this, args);
			}, delay);
		}
	}
}